module.exports = __webpack_public_path__ + "fonts/Inter-Bold.79260e5.woff";